import { Record } from 'immutable';

const UnmatchEventPartyRequestRecord = Record({
  type: null,
  code: null
});

export class UnmatchEventPartyRequest extends UnmatchEventPartyRequestRecord {
  type: string;
  code: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unmatch-event-party-request.ts